import { ReactNode } from 'react'

import { ContentPageSidebarHeader } from './Header'
import { ContentPageSidebarItem } from './Item'
import { ContentPageSidebarSection } from './Section'
import { Color, theme } from '../../constants'
import { Div } from '../Div'

const ContentPageSidebar = (props: { children: ReactNode }) => {
  return (
    <Div
      styles={{
        background: Color.WHITE,
        height: '100vh',
        position: 'sticky',
        top: 0,
        width: 320,
        overflow: 'auto',
        borderLeft: theme.border.style.thinLight,
        zIndex: theme.zIndex.contentpagesidebar,
      }}
    >
      {props.children}
    </Div>
  )
}

ContentPageSidebar.Header = ContentPageSidebarHeader
ContentPageSidebar.Item = ContentPageSidebarItem
ContentPageSidebar.Section = ContentPageSidebarSection

export { ContentPageSidebar }
